// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__jNxko","row":"styles_row__3O5G2"};